import React from 'react';

import { Column } from 'app/shopify/components/layout';

import { DatePicker } from './DatePicker';

export function DatePickerShowcase() {
  return (
    <Column padding="spacing.general.x4" alignItems="center">
      <DatePicker />
    </Column>
  );
}
